import React from 'react';
import clsx from 'clsx';
import Header from '../../components/Header/Header';
import Sidebar from '../../components/Sidebar/Sidebar';
import { Bar, Doughnut } from 'react-chartjs-2';
import { makeStyles } from '@material-ui/styles';
import InputLabel from '@material-ui/core/InputLabel';

import SaveIcon from '@material-ui/icons/Save';
import ReactToPdf from 'react-to-pdf';
import {
    IconButton,
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Select,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    MenuItem,
    Grid,
    Divider,
    Switch,
    TextField,
    Typography,
    colors
} from '@material-ui/core';
import { get_agency_overview, get_agencies, get_agency_guest_breakdown } from '../../api/API';
import moment from 'moment/moment.js'
import Autocomplete from '@material-ui/lab/Autocomplete';
import DatePicker from 'react-date-picker';
import { CSVLink } from "react-csv";

const useStyles = makeStyles(theme => ({
    root: {
        padding: '24px',
    },

}));

export default class ReportAgencyGuest extends React.Component {


    constructor(props) {
        super(props);
        this.colors = ["rgba(0, 99, 132, 0.6)", "rgba(99, 132, 0, 0.6)", "#3efa9f", "#21decb", "#3c8ae8", "#8438e0", "#e038cc", "#f0328b", "#eb2f4e"];

        this.ref = React.createRef();
        this.state = {
            csv_output: [],
            start_print: false,
            redraw: false,
            chartData: {},
            doughnuts: [],
            agencies: [],
            bar_options: {
                maintainAspectRatio: false,
                scales: {
                    yAxes: [{
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: 'Value'
                        },
                        ticks: {
                            min: 0,
                            max: 5,
                            stepSize: 1
                        }
                    }]
                }

            },
            values: {

                agencies: "",
                date_from: (moment().subtract(7, 'days').format('YYYY-MM-DD')),
                date_to: moment().format("yyyy-MM-DD"),
            },
            rawReport: []
        };

        this.get_showroom_data();
    }
    handleChange(e) {
        this.setState({
            ...this.state,
            values: {
                ...this.state.values,
                [e.target.name]: e.target.value
            }
        }, () => {
            this.get_data();
        });

    }

    async get_showroom_data() {
        var currentObj = this;
        let agencies = await get_agencies();
        if (agencies) {
            currentObj.setState({
                ...this.state,
                agencies: agencies,
                values: {
                    ...this.state.values,
                }
            }, () => {
                // this.get_data();
            });
        }
    }

    parse_chart_data(data) {
        var new_bar_options = {

        };
        var max_y_tick = 0;
        var labels = [];
        var doughnuts = [];
        var datasets = [];

        var uncategorized = [];
        var new_appointment = [];
        var prospect_appointment = [];
        var buyer_appointment = [];

        console.log("DATA", data);
        for (var i = 0; i < data.length; i++) {
            labels.push(data[i].agency);
            var temp_dataset = [];
            uncategorized.push(data[i].uncategorized_pax);
            // uncategorized.push(0);
            new_appointment.push(data[i].new_appointment_pax);
            // new_appointment.push(0);
            prospect_appointment.push(data[i].prospect_revisit_appointment_pax);
            buyer_appointment.push(data[i].buyer_appointment_pax);

            var total = data[i].total_pax;
            if (max_y_tick < total) {
                max_y_tick = total;
            }

        }
        datasets.push({
            label: "Uncategorized",
            data: uncategorized,
            backgroundColor: "#dadada"
        });
        datasets.push({
            label: "New Appointment",
            data: new_appointment,
            backgroundColor: "#a9d9ab"
        });
        datasets.push({
            label: "Prospect Revisit",
            data: prospect_appointment,
            backgroundColor: "#95cdf9"
        });
        datasets.push({
            label: "Buyer Revisit",
            data: buyer_appointment,
            backgroundColor: "#e895f9"
        });
        console.log('datasets', datasets);
        this.setState({
            ...this.state,
            chartData: {
                labels: labels,
                datasets: datasets
            },
            rawReport: data,
            bar_options: {
                ...new_bar_options,
                scales: {

                    xAxes: [{
                        stacked: true
                    }],
                    yAxes: [{
                        stacked: true,
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: 'Value'
                        },
                        ticks: {
                            min: 0,
                            max: max_y_tick + 5,
                            stepSize: 1,
                            beginAtZero: true
                        }
                    }]
                }
            }
        }, () => {
            this.downloadCSV();
        });

    }
    async get_data() {

        var agencies = this.state.values.agencies;
        let agency_arr = '';
        for (var i = 0; i < agencies.length; i++) {
            if (i == 0) {
                agency_arr += agencies[i].agency_id;
            } else {
                agency_arr += ',' + agencies[i].agency_id;
            }

        }
        var data = await get_agency_guest_breakdown({
            ...this.state.values,
            date_from: moment(this.state.values.date_from).format("yyyy-MM-DD"),
            date_to: moment(this.state.values.date_to).format("yyyy-MM-DD"),
            agencies: agency_arr,
        });
        if (data) {
            this.parse_chart_data(data.data);
        }
    }
    downloadCSV() {
        // var export_data = [];
        // var header = ['', 'Appt. Arrived', 'Appt. No Show', "Appt. Booked", "Appt. Total", "Guest Arrived", "Guest No Show", "Guest Booked", "Guest Total"];

        // export_data.push(header);

        // this.state.rawReport.map(row => {

        //     export_data.push([
        //         row.name,
        //         row.data.arrived,
        //         row.data.no_show,
        //         row.data.total - row.data.arrived - row.data.no_show,
        //         row.data.total,
        //         row.data.arrived_pax,
        //         row.data.no_show_pax,
        //         row.data.total_pax - row.data.arrived_pax - row.data.no_show_pax,
        //         row.data.total_pax
        //     ]);
        // });
        // this.setState({
        //     ...this.state,
        //     csv_output: export_data
        // }, () => {
        //     console.log(this.state)
        // }
        // );
    }

    render() {
        return (
            <React.Fragment>
                <Header
                    classes={this.props.classes}
                    onSidebarOpen={this.props.handleSidebarOpen}
                />
                <Sidebar
                    classes={this.props.classes}
                    onClose={this.props.handleSidebarClose}
                    open={this.props.shouldOpenSidebar}
                    variant={this.props.isDesktop ? 'persistent' : 'temporary'}
                />
                <main className={this.props.classes.content}>
                    <div className={this.props.classes.toolbar} />
                    <br></br>

                    <div
                        {...this.props}
                        className={clsx(this.props.classes.root, this.props.className)}
                        style={{
                            height: "auto",
                            padding: 8
                        }}
                    >
                        <Card>
                            <CardHeader
                                action={
                                    <>
                                        <ReactToPdf
                                            targetRef={this.ref}
                                            filename={"Agency_By_Properties_" + this.state.values.date_from + "_" + this.state.values.date_to + ".pdf"}
                                            scale={0.8}
                                            x={2}
                                            y={0}
                                            onComplete={(() => {
                                                this.setState({
                                                    ...this.state,
                                                    start_print: false,
                                                    redraw: true
                                                })
                                            }).bind(this)}
                                        >
                                            {({ toPdf }) => (
                                                <IconButton
                                                    onClick={(() => {
                                                        window.scrollTo(0, 0);
                                                        this.setState({
                                                            ...this.state,
                                                            start_print: true,
                                                            redraw: true
                                                        }, () => {
                                                            setTimeout(() => {

                                                                toPdf();
                                                            }, 2000);
                                                        });

                                                    }).bind(this)}
                                                >
                                                    <SaveIcon style={{ color: "black" }} />
                                                </IconButton>
                                            )}
                                        </ReactToPdf>
                                        <IconButton

                                        >
                                            <CSVLink
                                                data={this.state.csv_output}
                                                filename={"Agency_By_Properties_" + this.state.values.date_from + "_" + this.state.values.date_to + ".csv"}
                                            >
                                                <img style={{
                                                    width: 26
                                                }} src={require("../../assets/excel_icon.png")}></img>
                                            </CSVLink>
                                        </IconButton>
                                    </>
                                }
                                title="Agency Guest"
                            />
                            <Divider />
                            <CardContent class="report_container" className={useStyles.content}>
                                <div
                                    className="report_filter"
                                >
                                    <div className="filter_field_wrapper">
                                        <Autocomplete
                                            multiple
                                            id="tags-standard"
                                            name="unit"
                                            className="full_width"
                                            options={this.state.agencies}
                                            getOptionLabel={(option) => option.name}
                                            onChange={(event, newVal) => {
                                                this.setState({
                                                    ...this.state,
                                                    values: {
                                                        ...this.state.values,
                                                        agencies: newVal
                                                    }
                                                }, () => {
                                                    this.get_data();
                                                });
                                            }}
                                            renderInput={(params) => (
                                                <React.Fragment>

                                                    <TextField
                                                        {...params}
                                                        style={{
                                                            width: "100%"
                                                        }}
                                                        label="Agency"
                                                        placeholder='select agency'
                                                    />
                                                </React.Fragment>
                                            )}
                                        />
                                    </div>

                                    <div className="filter_field_wrapper">

                                        <TextField
                                            type="date"
                                            name="date_from"
                                            label="From"
                                            className="full_width"
                                            onChange={this.handleChange.bind(this)}
                                            value={this.state.values.date_from}

                                        />
                                    </div>
                                    <div className="filter_field_wrapper">

                                        <TextField
                                            type="date"
                                            name="date_to"
                                            className="full_width"
                                            label="to"
                                            onChange={this.handleChange.bind(this)}
                                            value={this.state.values.date_to}

                                        />
                                    </div>
                                    {/* <DatePicker
                                        format="dd/MM/y"
                                        onChange={date => this.setState({
                                            ...this.state,
                                            values: {
                                                ...this.state.values,
                                                date_from: date
                                            }
                                        }, () => {
                                            this.get_data();
                                        })}
                                        value={this.state.values.date_from}
                                        className="datepicker"
                                    ></DatePicker>
                                     <DatePicker
                                        format="dd/MM/y"
                                        onChange={date => this.setState({
                                            ...this.state,
                                            values: {
                                                ...this.state.values,
                                                date_to: date
                                            }
                                        }, () => {
                                            this.get_data();
                                        })}
                                        value={this.state.values.date_to}
                                        className="datepicker"
                                    ></DatePicker> */}


                                </div>
                                <div
                                    style={{
                                        width: this.state.start_print ? 900 : "auto"
                                    }}
                                    ref={this.ref}>
                                    {this.state.start_print && (
                                        <div style={{
                                            marginBottom: 30
                                        }}>
                                            <Grid container>
                                                <Grid item md={3}>
                                                    <img src={require("../../assets/logo_small.png")}></img>
                                                    <p>Showing date: {this.state.values.date_from} to {this.state.values.date_to}</p></Grid>
                                                <Grid item md={6} style={{
                                                    textAlign: 'center'
                                                }}>
                                                    <h1>Agency Breakdown</h1>
                                                </Grid>
                                            </Grid>


                                        </div>
                                    )}
                                    <div style={{
                                        height: '60vh',
                                        maxHeight: '20vh'
                                    }}>
                                        <Bar
                                            width={this.state.start_print ? 900 : 'auto'}
                                            options={{
                                                ...this.state.bar_options,
                                                maintainAspectRatio: false,
                                                devicePixelRatio: 3
                                            }}
                                            redraw={this.state.redraw}
                                            data={this.state.chartData}></Bar>
                                    </div>
                                    <br></br>
                                    <br></br>
                                    {this.state.rawReport && (
                                        <React.Fragment>
                                            <Table className="report_table hide_mobile">
                                                <TableHead>
                                                    <TableRow >
                                                        <TableCell></TableCell>
                                                    
                                                        <TableCell
                                                            style={{
                                                                textAlign: "center",
                                                                backgroundColor: "black",
                                                                color: "white"
                                                            }}
                                                            colSpan={5}>Guests</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell></TableCell>
                                                        <TableCell
                                                        >Uncategorized</TableCell>
                                                        <TableCell>New Prospect</TableCell>
                                                        <TableCell>Prospect Revisit</TableCell>
                                                        <TableCell>Buyer Revisit</TableCell>
                                                        <TableCell
                                                            className="bold"
                                                        >Total</TableCell>
                                                    </TableRow>
                                                </TableHead>

                                                <TableBody>
                                                    {this.state.rawReport.map((row) => (
                                                        <TableRow>
                                                            <TableCell className="bold">{row.agency}</TableCell>
                                                            <TableCell>{row.uncategorized_pax}</TableCell>
                                                            <TableCell>{row.new_appointment_pax}</TableCell>
                                                            <TableCell>{row.prospect_revisit_appointment_pax}</TableCell>
                                                            <TableCell>{row.buyer_revisit_appointment_pax}</TableCell>
                                                            <TableCell className="bold">{row.total_pax}</TableCell>

                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>


                                            <Table className="report_table hide_desktop">
                                                <TableHead>
                                                    <TableRow >
                                                        <TableCell></TableCell>
                                                        <TableCell style={{
                                                            textAlign: "center",
                                                            backgroundColor: "black",
                                                            color: "white"
                                                        }}></TableCell>

                                                        <TableCell
                                                            style={{
                                                                textAlign: "center",
                                                                backgroundColor: "black",
                                                                color: "white"
                                                            }}
                                                            colSpan={4}>Guests</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell></TableCell>
                                                        <TableCell
                                                        >Uncategorized</TableCell>
                                                        <TableCell>New Prospect</TableCell>
                                                        <TableCell>Prospect Revisit</TableCell>
                                                        <TableCell>Buyer Revisit</TableCell>
                                                        <TableCell
                                                            className="bold"
                                                        >Total</TableCell>
                                                    </TableRow>
                                                </TableHead>

                                                <TableBody>
                                                    {this.state.rawReport.map((row) => (
                                                        <TableRow>
                                                            <TableCell className="bold">{row.agency}</TableCell>
                                                            <TableCell>{row.uncategorized_pax}</TableCell>
                                                            <TableCell>{row.new_appointment_pax}</TableCell>
                                                            <TableCell>{row.prospect_appointment_pax}</TableCell>
                                                            <TableCell>{row.buyer_appointment_pax}</TableCell>
                                                            <TableCell className="bold">{row.total_pax}</TableCell>

                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </React.Fragment>


                                    )}
                                    <br></br>
                                    <br></br>

                                </div>

                            </CardContent>
                        </Card>
                    </div>
                </main>
            </React.Fragment>
        )
    }
}
